export default {"src":"/_next/static/media/sauerkraut.07bd422d.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};